import React, { useState, useRef } from "react";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import StarRatingComponent from "react-star-rating-component";
import { useForm } from "react-hook-form";
import { usePostReviews } from "hooks/Reviews/usePostReview";
import Loader from "components/loader";

export default function LeaveReview() {
  const [token, setToken] = useState(false);
  const [rating, setRating] = useState(0);
  const captchaRef = useRef(null);

  const { status, mutateAsync } = usePostReviews();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    if (token && rating) {
      const postData = {
        name: data.name,
        email: data.email,
        rating: rating,
        review: data.review,
      };
      mutateAsync(postData).then((_) => {
        reset();
        setRating(0);
      });
    } else {
      alert(!token ? "Please verify captcha" : "Please select rating");
    }
  };

  const handleVerify = () => {
    setToken(true);
  };

  const onStarClick = (nextValue) => {
    setRating(nextValue);
  };

  return (
    <div className="bg-darkBlue font-opensans">
      <div className="w-full xl:w-8/12 justify-center mx-auto py-16 pl-6 px-4">
        <h2 className="text-4xl font-semibold text-white font-secondary">
          Leave a <span className="text-orange">Review</span>
        </h2>
        <p className="py-10 text-white">
          If you're a new client or a returning client, feel free to assess the
          experience you've had with us and leave a review here.
        </p>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex md:flex-row flex-col w-full lg:w-9/12 gap-x-4 py-8">
            <div className="flex flex-col w-full lg:w-1/2">
              <label className="pb-2 text-white">
                Name <span className="text-red">*</span>
              </label>
              <input
                type="text"
                className="py-1 rounded pl-2 text-gray-700"
                placeholder="Enter your name"
                name="name"
                {...register("name", { required: true })}
              />
              {errors.name && (
                <span className="text-red">This field is required</span>
              )}
            </div>
            <div className="flex flex-col w-full lg:w-1/2 lg:pt-0 pt-4">
              <label className="pb-2 text-white">Company/Business</label>
              <input type="text" className="py-1 rounded pl-2 text-gray-700" />
            </div>
          </div>

          <div className="flex md:flex-row flex-col w-full lg:w-9/12 gap-x-4 pb-8">
            <div className="flex flex-col w-full lg:w-1/2">
              <label className="pb-2 text-white">
                Email Address <span className="text-red">*</span>
              </label>
              <input
                type="text"
                className="py-1 rounded pl-2 text-gray-700"
                placeholder="Enter your email"
                name="email"
                {...register("email", { required: true })}
              />
              {errors.email && (
                <span className="text-red">This field is required</span>
              )}
            </div>
            <div className="flex flex-col w-full lg:w-1/2 lg:pt-0 pt-4">
              <label className="pb-2 text-white">
                Select Rating <span className="text-red">*</span>
              </label>
              <div className="flex gap-x-2">
                <StarRatingComponent
                  name="rate1"
                  starCount={5}
                  value={rating}
                  onStarClick={onStarClick}
                />
              </div>
            </div>
          </div>

          <div className="flex flex-col w-full lg:w-9/12 pt-8">
            <label className="pb-2 text-white">
              Reviews <span className="text-red">*</span>
            </label>
            <textarea
              name=""
              id=""
              cols="30"
              rows="4"
              placeholder="Please write your review here"
              className="pl-2 text-gray-700"
              name="review"
              {...register("review", { required: true })}
            ></textarea>
            {errors.review && (
              <span className="text-red">This field is required</span>
            )}
          </div>

          <div className="flex mx-auto  pt-4">
            <HCaptcha
              sitekey="b6b06718-08ae-457f-a6d7-147046b4c216"
              onVerify={handleVerify}
              ref={captchaRef}
            />
          </div>
          <button
            type="submit"
            className="bg-orange text-white py-2 px-10 mb-4 rounded-full mx-auto cursor-pointer font-light mt-6"
          >
            {status === "loading" ? <Loader /> : "SUBMIT"}
          </button>
        </form>
      </div>
    </div>
  );
}
